import BookData from '../data/bookData.json'
import { useState } from "react"
import BookQuote from "../Components/BookQuote"
import Dice from "../image/dice.svg"
import Blurb from "../Components/Blurb"
import React, { useRef } from 'react'
import LoadingBar from 'react-top-loading-bar'
import { Link } from "react-router-dom"
import { useEffect } from "react"
import ElevateAppBar from "../Components/Header"
import RasterAd from '../Components/RasterAd'

const RandomBook = () => {

    var randomNumber = Math.floor(Math.random() * BookData.length)
    const [randomKey, setRandomKey] = useState(randomNumber)
    const ref = useRef(null)

    const generateRandomBook = () => {
        const randomKey = Math.floor(Math.random() * BookData.length)
        setRandomKey(randomKey);
        ref.current.complete();
    }

    useEffect(() => 
    window.scrollTo({top: 0, behavior: 'smooth'})
    
    );

    return ( 
       
        <div className='random-book'> 
            <ElevateAppBar></ElevateAppBar>
            
            <div className='random-book-button-container'>
                <div className='random-book-button' onClick={() => generateRandomBook()}>
                    <img src={Dice} alt="DICE"></img>
                    <span>Find Random Book</span>
                </div>
            </div>

                <div className='random-content'>
                    
                    <div className= 'left-row'>
                        <div className= 'random-book-title'>
                                <h2 className = 'random-title'>  {BookData[ randomKey ].title }</h2>
                                <h2 className= 'random-author'>By {BookData[ randomKey ].author }</h2> 
                                
                                <div className='left-row-buttons'>

                                
                                </div>
                            </div>
                        <div className='random-cover'>
                           
                           <Link className='cover-link' to={BookData[randomKey].key}><img src = {BookData[ randomKey ].cover} alt='cover'></img></Link>
                            

                        </div>

                            

                            
                                 
                        </div>

                    <div className='random-text'>

                        <div className='random-quote'>
                            <BookQuote className='random-quote-single' quote= {BookData[ randomKey ]["quote-1"] }/>
                            <BookQuote className='random-quote-single' quote= {BookData[ randomKey ]["quote-2"] }/>
                            <BookQuote className='random-quote-single' quote= {BookData[ randomKey ]["quote-3"] }/>
                        </div>

                        <div className='random-blur blurb'>
                            <h3 id='randomized-blurb'>{BookData[randomKey]['blurb']}</h3>
                        </div>

                       
                    </div>

            <LoadingBar color='var(--accent)' ref={ref} />

            
            
            
                </div><div className='detailAd'> <RasterAd></RasterAd></div>
                <br/><br/>


        </div>

        
     );
}
 
export default RandomBook;